import React from "react";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import { getTipoDocumento, desactivarTipoDocumento, getDocumento } from "../tiposDocumento/TipoDocumentoService";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import "../../scripts.jsx";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones.js";
import NavbarConfiguraciones from "../componentes/NavbarConfiguraciones.js";
import TablaItemsConfiguracion from "../componentes/tablas/TablaItemsConfiguracion.js";

class TiposDocumentos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nuevo Tipo de Documento",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedTipoDocumento: {
        nombre: "",
        formato: "",
        firmaEmpresa: true,
        acciones: "",
        id: "",
      },
      documentoSeleccionado: null,
      nuevoTipoDocumento: false,
      editarTipoDocumento: false,
      verTipoDocumento: false,
      eliminarTipoDocumento: false,
      restaurarTipoDocumento: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",
      openPantallaCarga: false
    };
    this.modalRef = React.createRef(); //referencia al modal
    this.tablaRef = React.createRef(); //referencia a la tabla de elementos
    this.modalEliminarRef = React.createRef();
  }


  handleOpenNuevoTipoDocumento = () => {
    this.setState({ nuevoTipoDocumento: true });
  };

  abrirModalEliminar = (estado, documento = null) => {
    this.setState({
      eliminarTipoDocumento: estado,
      documentoSeleccionado: documento,
    });
  }

  cerrarModalEliminar = () => {
    this.setState({ eliminarTipoDocumento: false });
  }

  handleDialogRestaurarDocumento = (value) => {
    this.setState({
      restaurarTipoDocumento: value,
    });
  };

  handleEditarTipoDocumento = (dato) => {
    this.props.history.push({
      pathname: '/configuracion/tipo-documento/edit',
      state: { datos: dato }
    })
  }

  handleDialogVerDatos = (estado, id = null) => {
    this.setState({ verTipoDocumento: estado, documentoSeleccionado: id }, () => {
      if (estado && id && this.modalRef) {
        this.modalRef.cargarDetalles(id);
      }
    });
  };

  handleDeleteTipoDocumento = () => {
    this.modalEliminarRef.cerrarModalConAnimacion()
    this.setState({ openPantallaCarga: true });
    let tipoDocumento = this.state.documentoSeleccionado

    desactivarTipoDocumento(tipoDocumento.id).then((resp) => {
      this.setState({
        openPantallaCarga: false,
        mostrarMensajeFlash: true,
        mensajeFlash: resp.mensaje,
        mensajeFlashSeverity: resp.error ? 'error' : 'exito'
      });
      this.actualizarDatosTabla()
    })
  }

  fetchDocumentos = (page, pageSize, search) => {
    return this.props.getTipoDocumento(page, pageSize, search).then(() => {
      const { tipoDocumentoData } = this.props;
      return {
        items: tipoDocumentoData.tipoDocumento,
        totalCount: tipoDocumentoData.totalCount,
      };
    });
  };

  renderDatosModal = (data) => {
    let datos = data.datos
    return(
      <div className="card">
        <p className="card-title">Datos Básicos</p>
        <div className="card-content">
          <div className="content-inner">
            <span className="label">Nombre</span>
            <span className="txt">{datos.nombre}</span>
          </div>
          <div className="content-inner">
            <span className="label">Descripción</span>
            <span className="txt">{datos.descripcion}</span>
          </div>
          <div className="content-inner">
            <span className="label">Formato</span>
            <span className="txt">{datos.formato.extension}</span>
          </div>
          <div className="content-inner">
            <span className="label">Nombre de archivo c/ metadato</span>
            <span className="txt">{datos.metaFromato}</span>
          </div>
          <div className="content-inner">
            <span className="label">Origen del lote</span>
            <span className="txt">{datos.origenLote.nombre}</span>
          </div>
        </div>
        <p className="card-title">Opciones de firma</p>
        <div className="card-content">
          <div className="content-inner">
            <span className="label">Firma empresa</span>
            <span className="txt">{datos.firmaEmpresa ? 'Si' : 'No'}</span>
          </div>
          <div className="content-inner">
            <span className="label">Acciones del colaborador</span>
            <span className="txt">{datos.firmaEmpleado.nombre}</span>
          </div>
          <div className="content-inner">
            <span className="label">Comentarios del colaborador</span>
            <span className="txt">{datos.isComentarioColaborador ? 'No' : 'Si'}</span>
          </div>
          <div className="content-inner">
            <span className="label">Tipo envio MTESS</span>
            <span className="txt">{datos.tipoEnvioMtess}</span>
          </div>
        </div>
      </div>
    )
  }

  renderFilas = (filas) => {
    return filas.map((f) => (
      <tr key={f.id}>
        <td>{f.nombre}</td>
        <td>{f.formato}</td>
        <td>{f.tipoFirmaEmpleado}</td>
        <td>{f.firmaEmpresa ? "SI" : "NO"}</td>
        <td>
          <div className="table-actions">
            <button className="table-icon open-dialog" data-dialog="modal-detalle-documento"
              data-id={f.id} onClick={() => this.handleDialogVerDatos(true, f.id)}>
              <span className="material-symbols-outlined"> visibility </span>
            </button>
            <button className="table-icon open-dialog" onClick={() => this.handleEditarTipoDocumento(f)}>
              <span className="material-symbols-outlined"> edit </span>
            </button>
            <button className="table-icon open-dialog" data-dialog="modal-delete-details" data-id={f.id}
              onClick={() => this.abrirModalEliminar(true, f)}>
              <span className="material-symbols-outlined"> delete </span>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  actualizarDatosTabla = () => {
    if (this.tablaRef) {
      this.tablaRef.fetchData();
    }
  }


  render() {

    return (
      <div>
        <div className="template-base">
          <PantallaCarga open={this.state.openPantallaCarga} />

          <NavbarConfiguraciones
            titulo={"Tipos de documentos"}
            descripcion={""}
            textoBoton={"Nuevo tipo documento"}
            direccionBoton={"/configuracion/tipo-documento/add"}
          />
          <div className="wrapperContent">
            <div className="page-container">
              <TablaItemsConfiguracion
                ref={(ref) => (this.tablaRef = ref)}
                titulo="Tipos de documentos disponibles"
                headers={["Nombre", "Formato de importacion", "Acciones del colaborador", "Firma de empresa", "Acciones"]}
                fetchDatos={this.fetchDocumentos}
                renderFilas={this.renderFilas}

              />
            </div>
          </div>


          <ModalDetalleConfiguraciones
            ref={(ref) => (this.modalRef = ref)}
            abierto={this.state.verTipoDocumento}
            onClose={() => this.handleDialogVerDatos(false)}
            fetchDetalle={getDocumento}
            titulo="Detalles del tipo documento"
            renderContenido={(datos) => this.renderDatosModal(datos)} />

        </div>
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />

        <ModalEliminarConDetalles
          ref={(ref) => (this.modalEliminarRef = ref)}
          isOpen={this.state.eliminarTipoDocumento}
          cerrarModal={this.cerrarModalEliminar}
          elemento={this.state.documentoSeleccionado}
          onConfirmar={this.handleDeleteTipoDocumento}
          titulo="tipo de documento"
          detallesAMostrar={[
            { clave: 'nombre', etiqueta: 'Nombre del Tipo documento' },
            { clave: 'formato', etiqueta: 'Formato' },
          ]}
          mensaje="Esta acción eliminará permanentemente el documento"
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getTipoDocumento: (page, size, search) =>
    dispatch(getTipoDocumento(page, size, search)),
});

const mapStateToProps = (state) => ({
  tipoDocumentoData: state.tipoDocumentoData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TiposDocumentos);
